// extracted by css-extract-rspack-plugin
export default {"Board":"Board-module__Board__Au6yp","ColumnHeaders":"Board-module__ColumnHeaders__e8hN0","Rows":"Board-module__Rows__figWW"};